/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxGamesLibWebRpcContractsResponseResponseError } from './FxGamesLibWebRpcContractsResponseResponseError';
import {
    FxGamesLibWebRpcContractsResponseResponseErrorFromJSON,
    FxGamesLibWebRpcContractsResponseResponseErrorFromJSONTyped,
    FxGamesLibWebRpcContractsResponseResponseErrorToJSON,
    FxGamesLibWebRpcContractsResponseResponseErrorToJSONTyped,
} from './FxGamesLibWebRpcContractsResponseResponseError';

/**
 * 
 * @export
 * @interface FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult
 */
export interface FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult {
    /**
     * 
     * @type {boolean}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult
     */
    Success: boolean;
    /**
     * 
     * @type {object}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult
     */
    Data: object;
    /**
     * 
     * @type {FxGamesLibWebRpcContractsResponseResponseError}
     * @memberof FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult
     */
    Error?: FxGamesLibWebRpcContractsResponseResponseError | null;
}

/**
 * Check if a given object implements the FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult interface.
 */
export function instanceOfFxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult(value: object): value is FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult {
    if (!('Success' in value) || value['Success'] === undefined) return false;
    if (!('Data' in value) || value['Data'] === undefined) return false;
    return true;
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResultFromJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult {
    return FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResultFromJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult {
    if (json == null) {
        return json;
    }
    return {
        
        'Success': json['Success'],
        'Data': json['Data'],
        'Error': json['Error'] == null ? undefined : FxGamesLibWebRpcContractsResponseResponseErrorFromJSON(json['Error']),
    };
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResultToJSON(json: any): FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult {
    return FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResultToJSONTyped(json, false);
}

export function FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResultToJSONTyped(value?: FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Success': value['Success'],
        'Data': value['Data'],
        'Error': FxGamesLibWebRpcContractsResponseResponseErrorToJSON(value['Error']),
    };
}

